<template>
  <el-dialog
    class="check-block-info common-dialog"
    title="查询区块信息"
    :visible.sync="showDialog"
    top="30vh"
    @open="onShow"
    @closed="onClosed"
  >
    <el-form
      ref="checkBlockInfo"
      :model="model"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="链ID" prop="chainId">
        <el-select v-model="model.chainId" placeholder="请选择区块链" class="chain-select">
          <el-option
            v-for="item in handleInfo?.Chains"
            :key="item.id"
            :label="item.chainId"
            :value="item.chainId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区块Hash" prop="hash">
        <el-input v-model="model.hash" placeholder="请输入区块Hash"></el-input>
      </el-form-item>
      <el-form-item label="区块高度" prop="height">
        <el-input-number
          v-model="model.height"
          :min="0"
          step-strictly
          placeholder="请输入区块高度"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="交易ID" prop="txKey">
        <el-input v-model="model.txKey" placeholder="请输入交易ID"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'CheckBlockInfo',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 140
  },
  props: {
    dialogVisible: Boolean,
    handleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      model: {
        chainId: null,
        hash: null,
        height: undefined,
        txKey: null
      },
      rules: {
        chainId: [{ required: true, message: '请选择区块链', trigger: ['blur', 'change'] }],
        hash: [{ required: false, message: '请输入区块Hash', trigger: ['blur', 'change'] }],
        height: [{ required: false, message: '请输入区块高度', trigger: ['blur', 'change'] }],
        txKey: [{ required: false, message: '请输入交易ID', trigger: ['blur', 'change'] }]
      },
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 140
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  mounted() {},
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs.checkBlockInfo.validate(valid => {
        if (valid) {
          console.log('submit!')

          self.$apis.spvlightnodes
            .deliver({
              chainId: self.model.chainId,
              fromRemote: true,
              spvId: self.handleInfo.id,
              hash: self.model.hash || null,
              height: parseInt(self.model.height),
              txKey: self.model.txKey || null
            })
            .then(res => {
              if (res && !res.errors && res.data) {
                self.showDialog = false

                self.$emit('checkSuccess', res.data)
                self.$message({
                  type: 'success',
                  message: '调用SPV服务成功!'
                })
              } else {
                self.$emit('checkFailed')
                self.$message({
                  type: 'error',
                  message: '调用SPV服务失败!'
                })
              }
            })
            .catch(err => {
              self.$emit('checkFailed')
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onShow() {},
    onClosed() {
      this.model = {
        chainId: null,
        hash: null,
        height: undefined,
        txKey: null
      }
      let self = this
      this.$nextTick(() => {
        self.$refs.checkBlockInfo.clearValidate()
      })
    }
  }
}
</script>
<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('check-block-info', (), ());
.check-block-info {
  @include adaptation((
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
